<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48">
  <path
    d="M45.707 14.6l-12.3-12.3A1 1 0 0032.7 2H15.3a1 1 0 00-.707.293L2.293
    14.6a1 1 0 00-.293.7v17.4a1 1 0 00.293.707l12.3 12.3A1 1 0 0015.3 46h17.4a1
    1 0 00.707-.293l12.3-12.3A1 1 0 0046 32.7V15.3a1 1 0 00-.293-.7zM24 38a2 2 0
    112-2 2 2 0 01-2 2zm1.045-7.829h-2.051L22 9.487h4.043z"
    fill="#b1a700" />
</svg>
